/* eslint-disable @typescript-eslint/naming-convention */
export const CHECKLIST_BUTTON_DEFAULT_COLORS: {
  Text: string,
  Value: { BackgroundColor: string, ForegroundColor: string } | null
}[] = [
  {
    Text: 'None',
    Value: {
      BackgroundColor: '',
      ForegroundColor: ''
    }
  },
  {
    Text: 'Green',
    Value: {
      BackgroundColor: '#3FAD10',
      ForegroundColor: '#267A02'
    }
  }, {
    Text: 'Yellow',
    Value: {
      BackgroundColor: '#E3BD14',
      ForegroundColor: '#9C7003'
    }
  }, {
    Text: 'Orange',
    Value: {
      BackgroundColor: '#E86215',
      ForegroundColor: '#A33903'
    }
  }, {
    Text: 'Red',
    Value: {
      BackgroundColor: '#DE1B14',
      ForegroundColor: '#9C0803'
    }
  }, {
    Text: 'Purple',
    Value: {
      BackgroundColor: '#8015DE',
      ForegroundColor: '#5905A3'
    }
  }, {
    Text: 'Teal',
    Value: {
      BackgroundColor: '#14D9C5',
      ForegroundColor: '#039C8C'
    }
  }, {
    Text: 'Blue',
    Value: {
      BackgroundColor: '#139CD8',
      ForegroundColor: '#025FAB'
    }
  }, {
    Text: 'Grey',
    Value: {
      BackgroundColor: '#5B6876',
      ForegroundColor: '#25303C'
    }
  },
  {
    Text: 'Custom',
    Value: {
      BackgroundColor: '#6F7E8C',
      ForegroundColor: '#404E5C'
    }
  }
];